import { Accordion } from '@base-ui/react/accordion';
export function Root(props) {
    const { defaultOpenSectionsIds, children } = props;
    return (<Accordion.Root multiple defaultValue={defaultOpenSectionsIds}>
      {children}
    </Accordion.Root>);
}
